import React, { useState } from 'react';
import { QUERIES } from '../../api/queries';
import { useQuery } from '@apollo/react-hooks';
import { Table, Spin, Row, Col, Icon } from 'antd';

const OrderStatusSettings = props => {

  const [orderStatuses, setOrderStatuses] = useState(null);

  const { loading, error, refetch } = useQuery(QUERIES.ORDER_STATUSES, {
    onCompleted: res => {
        let statuses = res.orderStatuses;
        statuses.sort((a,b)=>{
            return b.index - a.index;
        });

        setOrderStatuses(statuses);
    }
  });

  const columns = [
    {
      title: 'Status',
      render: record => {
           if(record.index > 0)
                return (<p><Icon style={{color: "green", marginRight: "15px"}} type="up"/> {record.name}</p>)
            else
                return (<p><Icon style={{color: "red", marginRight: "15px"}} type="down"/> {record.name}</p>)
          
      },
      key: record => record.id+"Name",
    },
    {
      title: 'Code',
      render: record => record.code,
      key: record => record.id+"Code",
    }
  ];

  if (!loading && !error && !!orderStatuses) {
    return (
      <div>
        <Row type='flex' justify='center'>
          <Table
            rowKey={record => record.id}
            style={{ width: '80vw', margin: 16 }}
            dataSource={orderStatuses}
            columns={columns}
          />
        </Row>
      </div>
    );
  }

  return (
    <div>
      <Row type='flex' justify='center'>
        <Col span={24}>
          <Spin size='large' />
        </Col>
      </Row>
    </div>
  );

};

export default OrderStatusSettings;